import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Pricing from "@/pages/Pricing";
import Mobility from "@/pages/Mobility";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CandidateApp from "@/pages/CandidateApp";
import EmployerDashboard from "@/pages/EmployerDashboard";
import CandidateProfile from "@/pages/CandidateProfile";
import AdminPortal from "@/pages/AdminPortal";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Legal from "@/pages/Legal";
import TeamShared from "@/pages/TeamShared";
import TeamInvite from "@/pages/TeamInvite";
import ReferencePage from "@/pages/ReferencePage";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted font-mono text-sm">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "super_admin")
    return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App ta-noise min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/mobility" element={<Mobility />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/legal/:doc" element={<Legal />} />
            <Route path="/team/shared/:token" element={<TeamShared />} />
            <Route path="/team-invite" element={<TeamInvite />} />
            <Route path="/reference/:token" element={<ReferencePage />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/candidate" element={<Protected roles={["candidate"]}><CandidateApp /></Protected>} />
            <Route path="/employer" element={<Protected roles={["startup_employer"]}><EmployerDashboard /></Protected>} />
            <Route path="/employer/candidate/:id" element={<Protected roles={["startup_employer"]}><CandidateProfile /></Protected>} />
            <Route path="/admin" element={<Protected roles={["admin","super_admin"]}><AdminPortal /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
